import { toTitleCase } from '@vrplatform/utils';
import { AutomationMappingEditor } from '../../../components';
import { AutomationSettingsEditor } from '../../../components/automation-settings';
import { useStatementAutomation } from '../legacy/_hooks';

const StatementBillAccountInput = ({
  withOverrideModal,
}: {
  withOverrideModal?: boolean;
}) => {
  const { billAutomation } = useStatementAutomation();

  const billMappingKey = 'billAccount';

  const billMapping = Object.entries(billAutomation?.mappings || {}).find(
    ([key]) => key === billMappingKey
  );

  if (!billAutomation || !billMapping) return null;

  return (
    <AutomationMappingEditor
      automation={{
        automationId: billAutomation.automationId,
        leftConnectionId: billAutomation.leftConnectionId,
        rightConnectionId: billAutomation.rightConnectionId,
        leftAppId: billAutomation.leftConnection?.appId,
        rightAppId: billAutomation.rightConnection?.appId,
        templateId: billAutomation.templateId,
      }}
      mapping={{
        isLocal: false,
        leftType: billMapping[1].left.schema,
        rightType: billMapping[1].right.schema,
        label: billMapping[1].label || toTitleCase(billMappingKey)!,
        settingKey: billMappingKey,
        altLeftTypes: billMapping[1].left.alt,
        exceptionFilters: billMapping[1].params?.exceptionFilters,
        rightParams: billMapping[1].right?.params || {},
        leftParams: billMapping[1].left?.params || billMapping[1].params || {},
      }}
      parentSetting={null}
      targetId="*"
      withOverrideModal={withOverrideModal}
    />
  );
};

const BalanceDateInput = () => {
  const { automation } = useStatementAutomation();

  const balanceSettingKey = 'balanceStartDate';

  if (!automation?.automationId) return null;

  return (
    <AutomationSettingsEditor
      automationId={automation.automationId}
      settingKey={balanceSettingKey}
      settings={automation.settings}
      leftConnectionId={automation.leftConnectionId}
      rightConnectionId={automation.rightConnectionId}
    />
  );
};
export const StatementAutomationSettingInputs = {
  BillAccount: StatementBillAccountInput,
  BalanceStartDate: BalanceDateInput,
};
